<template>
    <div class="batch-policy-comp">
        <div class="left table-list">
            <div class="mask"></div>
            <div v-if="housesCid.length" class="selected-tips">
                <div class="wording">
                    已選取 {{housesCid.length}} 個房源
                </div>
            </div>
            <div v-if="this.filterTag.length" class="filter-tips">
                <span class="result">
                    {{filterByWord.length}} 個結果
                </span>
                <span class="item" v-for="(item, index) in this.filterTag" :key="index">
                    {{item}}
                </span>
            </div>
            <div class="table-list-title">
                <span @click="clearSuccessFlag" class="checkbox">
                    <checkbox v-model="checkboxStatus.checkboxAll"  :isPropChecked="checkboxStatus.checkboxAll"></checkbox>
                </span>
                <span class="address">地址</span>
                <span class="house-type">類型</span>
                <span class="policy">政策</span>
                <span class="landlord">房東</span>
                <span class="sales">業務</span>
            </div>
            <div class="table-list-body">
                <div v-if="isLoading" class="filter-empty">
                    <table-loading />
                </div>
                <div v-else-if="filterByWord.length == 0 && batchPolicyList.length != 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
                </div>
                <div v-else-if="batchPolicyList.length == 0" class="is-empty">0 筆資料</div>
                <ul v-else>
                    <li v-for="(list,index) in filterByWord" :key="index">
                        <span class="checkbox" @click="clearSuccessFlag">
                            <checkbox :val="list.houseId" v-model="housesCid" :isPropChecked="checkboxStatus.checkboxAll || checkboxStatus.forceUpdate"></checkbox>
                        </span>
                        <span class="address">
                            {{list.address.length >= 15?compressWord(list.address, 15):list.address}}
                            <div v-if="list.address.length >= 15" class="full-word">
                                <span>
                                    {{list.address}}
                                </span>
                            </div>
                        </span>
                        <span class="house-type">{{houseType(list.houseType)}}</span>
                        <span class="policy">
                            <span class="to-dot" v-for="(policy, pIndex) in list.policy" :key="pIndex">
                                {{policy}}
                            </span>
                        </span>
                        <span class="landlord">
                            {{list.landlordName && list.landlordName.length >= 4?compressWord(list.landlordName, 4):list.landlordName}}
                            <div v-if="list.landlordName && list.landlordName.length >= 4" class="full-word">
                                <span>
                                    {{list.landlordName}}
                                </span>
                            </div>
                        </span>
                        <span class="sales">
                            <span class="group">
                                {{list.groupName && list.groupName.length >= 3?compressWord(list.groupName, 3):list.groupName}}
                                <div v-if="list.groupName && list.groupName.length >= 3" class="full-word">
                                    <span>
                                        {{list.groupName}}
                                    </span>
                                </div>
                            </span>
                            <span>/</span>
                            <span class="agent">
                                {{list.salesName && list.salesName.length >= 4?compressWord(list.salesName, 4):list.salesName}}
                                <div v-if="list.salesName && list.salesName.length >= 4" class="full-word">
                                    <span>
                                        {{list.salesName}}
                                    </span>
                                </div>
                            </span>
                        </span>
                        <span v-if="successFlag[index]">
                            <img src="@/assets/img/icon/success_done.svg" alt="">
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right">
            <batch-policy-filter></batch-policy-filter>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import batchPolicyFilter from '@/components/bussiness/mgtCategory/houseMgt/batchPolicy/batchPolicyFilter.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            checkboxStatus: {
                checkboxAll: false,
                forceUpdate: null
            },
            housesCid: [],
            successFlag: [],
            isLoading: true
        }
    },
    created () {
        this.$store.dispatch('getBizBatchPolicyList')
        .then(()=>{
            this.isLoading = false
        })
    },
    watch: {
        // batchPolicyList: {
        //     handler: function (val) {
        //         console.log(val)
        //         for (let i = 0; i < val.length; i++) {
        //             this.checkboxStatus.checkboxList[i] = false
        //         }
        //     },
        //     immediate: true
        // } ,
        checkboxStatus: {
            handler: function (val) {
                console.log(val)
                setTimeout(()=>{
                    this.$store.dispatch('setCheckboxStatus', val)
                },500)
            },
            deep: true
        },
        housesCid: {
            handler: function (val) {
                this.$store.dispatch('setSeletedHouse', val)
                if(val.length === 0){
                    this.checkboxStatus.checkboxAll = false
                }else if(this.filterByWord.length === val.length){
                    this.checkboxStatus.checkboxAll = true
                }
            },
            deep: true
        },
        filterQueryUpdate: function () {
            this.clearCheckbox()
        },
        'checkboxStatus.checkboxAll': function (val) {
            let list = this.filterByWord
            if(val){
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if(!this.housesCid.includes(element.houseId)){
                        this.housesCid.push(element.houseId)
                    }
                }
            }else{
                this.housesCid = []
            }
        },
        successList: function (val) {     
            this.clearCheckbox()
            for (let i = 0; i < this.filterByWord.length; i++) {
                const element = this.filterByWord[i];
                if(val.includes(this.filterByWord[i].houseId)){
                    this.successFlag[i] = true
                }
            }
        }
    },
    methods: {
        clearCheckbox: function () {
            this.checkboxStatus.forceUpdate = false
            this.housesCid = []
            setTimeout(()=>{
                this.checkboxStatus.forceUpdate = null
            }, 500)
        },
        clearSuccessFlag: function () {
            this.successFlag = []
        }
    },
    computed: {
        filterByCounty: function () {
            return this.batchPolicyList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.city.includes(this.filterQuery.county) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district.includes(this.filterQuery.district) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByHouseType: function () {
            return this.filterByDistrict.filter((item) => {
                if( this.filterQuery.houseType ){
                    if( this.filterQuery.houseType == item.houseType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByBuildingType: function () {
            return this.filterByHouseType.filter((item) => {
                if( this.filterQuery.buildingType ){
                    if( this.filterQuery.buildingType == item.buildingType ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByBuildingType.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.salesName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByLandlord: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.landlord){
                    if(item.landlordName == this.filterQuery.landlord){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByLandlord.filter((item) => {
                this.filterQueryUpdate
                if( this.filterQuery.word ){
                    if( item.address.includes(this.filterQuery.word) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterTag: function () {
            let filterTag = []
            let index = 0
            for( var item in this.filterQuery ){
                let filterValue = this.filterQuery[item]
                if(filterValue && item != 'countyId'){
                    filterValue = this.transFilterTagContent(item, filterValue)
                    filterTag[index] = this.transFilterTagTitle(item)+'：'+filterValue
                    index++
                }
            }
            return filterTag
            
        },
        ...mapGetters({
            batchPolicyList: 'GET_BIZ_BATCH_POLICY_LIST',
            filterQuery: 'GET_BIZ_BATCH_POLICY_FILTER_QUERY',
            filterQueryUpdate: 'GET_BIZ_BATCH_POLICY_FILTER_QUERY_UPDATE',
            successList: 'GET_BIZ_BATCH_POLICY_SUCCESS_LIST'
            // housesCid: 'GET_BIZ_BATCH_POLICY_SELECTED_HOUSE_CID',
            // policyCid: 'GET_BIZ_BATCH_POLICY_SELECTED_POLICY_CID'
        })
    },
    components: {
        Checkbox,
        batchPolicyFilter,
        tableLoading
    }
}
</script>
<style lang="scss">
    .batch-policy-comp{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .table-list{
            width: 850px;
            .table-list-title{
                padding: 16px;
            }
            .table-list-body ul li{
                padding: 16px;
            }
            .checkbox{
                width: 20px;
                margin-right: 16px;
            }
            .address{
                width: 220px;
                margin-right: 29px;
            }
            .house-type{
                width: 56px;
                margin-right: 29px;
            }
            .policy{
                width: 220px;
                margin-right: 29px;
                line-height: 1.5;
            }
            .landlord{
                width: 42px;
                margin-right: 29px;
            }
            .sales{
                width: 115px;
                display: flex;
                align-items: center;
                .group{
                    width: 55px;
                }
            }
        }
    }
    .page-setting.fixed .batch-policy-comp .table-list .table-list-title {
        position: relative;
        top: unset;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/batchPolicy/batchPolicyComp.vue